import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { withInject } from '@piwikpro/platform';

const Checkout = withInject({ Checkout: 'MarketingCrate.components.Checkout' })(
  ({ Checkout: CO }: any) => <CO />
);

/** Public Paddle checkout — sibling of `/payment`, not nested in its outlet. */
export const Route = createFileRoute('/payment_/checkout')({
  component: Checkout,
});
